<p-fluid>
  <p-autoComplete [(ngModel)]="selectedTradePartner" (ngModelChange)="propagateChange($event); propagateModelTouched()"
    #tradePartnerSelection="ngModel" name="tradePartnerSelection" optionLabel="name"
    [suggestions]="tradePartnerSuggestions()" (completeMethod)="onComplete($event)" size="30"
    emptyMessage="No Trade Partners" [dropdown]="true" [forceSelection]="forceSelection()" [placeholder]="label"
    (onClear)="clearTradePartner()" [disabled]="disabled" [required]="required()" (onFocus)="focused.emit()"
    [appendTo]="appendTo()">
    @if(showBusinessName()) {
    <ng-template #header>
      <div class="trade-partner-autocomplete-header">
        <p-button icon="pi pi-sort-alt" [label]="buttonLabel()" severity="secondary"
          (onClick)="toggleSortOrder()"></p-button>
      </div>
    </ng-template>
    }
    <ng-template let-vendor #item>
      <div class="d-flex flex-column gap-2">
        <div>{{ vendor.name }}</div>
        @if(showBusinessName() && vendor.businessAsName !== vendor.name) {
        <div class="dba-name">{{ vendor.businessAsName ?? "" }}</div>
        }
      </div>
    </ng-template>
  </p-autoComplete>
  <error-message [errorControl]="tradePartnerSelection">
    @if (tradePartnerSelection?.errors?.required && !isOneOfManyRequired()) {
    <span>Please select at least one trade partner to continue.</span>
    }
  </error-message>
</p-fluid>